import { useContainer } from '../../useContainer';
import { ToastStateHandler, UserApi } from '../../../api';
import { useTranslation } from '../../useTranslation';
import { UserDocumentPostDto } from '../../../commonTypes/user.types';
import { ACCESS_TOKEN, ID_TOKEN, LocalStorage } from '../../../util/LocalStorage';

const MAX_FILE_SIZE_BYTES = 5000000;

const useHttpUploadUserDocument = () => {
    const userApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);
    const storage = useContainer(LocalStorage);
    const { t } = useTranslation('newNotifications');

    const uploadUserDocument = ({ name, userSub, file, categoryId, description, onUploaded }: UserDocumentPostDto) => {
        userApi
            .uploadUserDocument({
                name,
                userSub,
                file,
                categoryId,
                description,
                accessToken: storage.get(ACCESS_TOKEN),
                idToken: storage.get(ID_TOKEN),
            })
            .then(res => {
                onUploaded(res.body);
                toastHandler.push(`success`, t('userDocuments.uploadTitle'), t('userDocuments.uploadSuccess'));
            })
            .catch(err => {
                console.log(err);
                if (file.size > MAX_FILE_SIZE_BYTES) {
                    toastHandler.push('error', t('userDocuments.uploadTitle'), t('userDocuments.maxLimitErrorMessage'));
                    return;
                } else {
                    toastHandler.push(`error`, t('userDocuments.uploadTitle'), t('userDocuments.uploadError'));
                }
            });
    };

    return { uploadUserDocument };
};

export default useHttpUploadUserDocument;
